const selectBusinessReducer = (state, action) => {
  switch (action.type) {
    case "SELECT_STAFF":
      return { ...state, staff: action.data };
    case "ADD_SERVICE": {
      const exists = state.services.some(
        (service) => service.id === action.data.id
      );

      if (exists) {
        return state; // ❌ duplicate found — no state change
      }

      return {
        ...state,
        services: [...state.services, action.data], // safe to add
      };
    }
    case "RESET_SERVICES":
      return { ...state, services: [], serviceType: null };
    case "REMOVE_SERVICE":
      return {
        ...state,
        services: state.services.filter(
          (service) => service.identifier !== action.data.identifier
        ),
        // Reset serviceType if no services left
        serviceType: state.services.length <= 1 ? null : state.serviceType,
      };
    case "UPDATE_SERVICE_QUANTITY":
      return {
        ...state,
        services: state.services.map((service) =>
          service.id === action.data.id
            ? { ...service, quantity: action.data.quantity }
            : service
        ),
      };
    case "SET_SERVICE_TYPE":
      return {
        ...state,
        serviceType: action.data, // 'individual' or 'group'
      };
    case "SELECT_DATE":
      return {
        ...state,
        date: action.data,
      };
    case "ADD_DISCOUNT":
      return {
        ...state,
        discount: action.data,
      };
    case "SELECT_HOUR":
      return {
        ...state,
        hour: action.data,
      };
    case "UPDATE_USER_DETAILS":
      return {
        ...state,
        userDetails: { ...state.userDetails, ...action.data },
      };
    case "FETCH_TOTAL_COST":
      return { ...state, totalCost: action.data };
    case "RESET_TOTAL_COST":
      return { ...state, totalCost: null };

    default:
      return state;
  }
};

export default selectBusinessReducer;
